export default {
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.list': 'List',
  'menu.welcome': 'Dashboard',
  'menu.dashboard': 'Dashboard',
  'menu.monitoring': 'Monitoring',
  'menu.communicationsList': 'Communication list',
  'menu.communicationEditor': 'Communication Editor',
  'menu.school': 'School',
  'menu.infrastructure': 'Infrastructure',
  'menu.infrastructure.users': 'Users',
  'menu.infrastructure.usersCards': 'Users (Cards)',
  'menu.infrastructure.roles': 'Roles',
  'menu.subject': 'Subjects',
  'menu.subject.subjectTypes': 'Subject Types',
  'menu.subject.subjects': 'Subjects',
  'menu.subject.organizations': 'Organizations',
  'menu.users': 'Users',
  'menu.roles': 'Roles',

  // @generated entity-menu
  'menu.communication': 'Communication',
  'menu.communication.communication': 'Communication',
  'menu.communication.communicationDetail': 'Communication detail',
  'menu.communication.communicationFolder': 'Communication folder',
  'menu.communication.communicationHistory': 'Communication history',
  'menu.communication.communicationPermission': 'Communication permission',
  'menu.communication.communicationStrategy': 'Communication strategy',
  'menu.communication.communicationSubject': 'Communication subject',
  'menu.communication.communicationVersion': 'Communication version',
  'menu.communication.communicationView': 'Communication view',
  'menu.communication.typeSubjectCommunication': 'Communication subject type',
  'menu.context': 'Context',
  'menu.context.contextClassifier': 'Context classifier',
  'menu.context.contextData': 'Context data item',
  'menu.context.contextPipeline': 'Context pipeline',
  'menu.context.contextStorage': 'Context storage',
  'menu.context.groupContextClassifier': 'Context classifier group',
  'menu.context.providerContext': 'Provider context',
  'menu.context.providerContextClassifier': 'Provider context classifier',
  'menu.context.resultContextClassifier': 'Result context classifier',
  'menu.context.shareContextStorage': 'Shared context storage',
  'menu.context.typeProviderContext': 'Provider context type',
  'menu.context.versionProviderContext': 'Provider context version',
  'menu.infrastructure.permission': 'Permission',
  'menu.infrastructure.role': 'Role',
  'menu.infrastructure.user': 'User',
  'menu.services': 'Services',
  'menu.services.aiModel': 'AI model',
  'menu.services.brokerEvent': 'Broker event',
  'menu.services.dataPipeline': 'Data pipeline',
  'menu.services.dataPipelineDetail': 'Data pipeline detail',
  'menu.services.dependentVersionService': 'Dependent service version',
  'menu.services.detailScheduler': 'Scheduler run detail',
  'menu.services.historyRunningPipeline': 'Pipeline run history',
  'menu.services.historyRunningStreamPipeline': 'Stream pipeline run history',
  'menu.services.injectionVersionService': 'Injection Version Service',
  'menu.services.pipeline': 'Pipeline',
  'menu.services.resultScheduler': 'Scheduler job result',
  'menu.services.running': 'Run type',
  'menu.services.scheduler': 'Scheduler',
  'menu.services.schemaPipeline': 'Schema pipeline',
  'menu.services.service': 'Service',
  'menu.services.serviceEvent': 'Service event type',
  'menu.services.serviceParams': 'Service parameter template',
  'menu.services.serviceType': 'Service type',
  'menu.services.serviceVersion': 'Service version',
  'menu.services.testPipeline': 'Test pipeline',
  'menu.services.testResultPipeline': 'Test pipeline result',
  'menu.services.tuneModel': 'Fine-tuning job',
  'menu.services.tuneModelResult': 'Tune model result',
  'menu.subject.application': 'Application',
  'menu.subject.division': 'Division',
  'menu.subject.individual': 'Individual',
  'menu.subject.organization': 'Organization',
  'menu.subject.organizationPosition': 'Organization position',
  'menu.subject.organizationStructure': 'Organizational structure',
  'menu.subject.organizationStructurePermission': 'Organization structure permission',
  'menu.subject.subject': 'Subject',
  'menu.subject.subjectType': 'Subject type',
  'menu.subject.userOrganizationStructure': 'User in organization structure',
};
